import { render, staticRenderFns } from "./disinfectionTest.vue?vue&type=template&id=475fe4bb&scoped=true&"
import script from "./disinfectionTest.vue?vue&type=script&lang=js&"
export * from "./disinfectionTest.vue?vue&type=script&lang=js&"
import style0 from "./disinfectionTest.vue?vue&type=style&index=0&id=475fe4bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fe4bb",
  null
  
)

export default component.exports